import React from "react";
import PropTypes from "prop-types";

import StandardComparisonGallery from "./StandardComparisonGallery";
import ComponentMissing from "../../Debug/ComponentMissing";

const ComparisonGallerySwitcher = ({
  layout,
  header,
  headerType,
  headerDisplayStyle,
  headerLink,
  headerLinkType,
  secondaryLink,
  secondaryLinkType,
  subline,
  teaser,
  comparisonCards,
  animation,
}) => {
  const properties = {
    header,
    headerType,
    headerDisplayStyle,
    headerLink,
    headerLinkType,
    secondaryLink,
    secondaryLinkType,
    subline,
    teaser,
    comparisonCards,
    animation,
  };

  function switchComparisonGallery() {
    switch (layout) {
      case "standard":
        return <StandardComparisonGallery properties={properties} />;
      default:
        return <ComponentMissing type="ComparisonGallery" subType={layout} />;
    }
  }

  return switchComparisonGallery();
};

ComparisonGallerySwitcher.propTypes = {
  layout: PropTypes.string,
  header: PropTypes.string,
  headerType: PropTypes.string,
  headerDisplayStyle: PropTypes.string,
  headerLink: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  headerLinkType: PropTypes.string,
  secondaryLink: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  secondaryLinkType: PropTypes.string,
  subline: PropTypes.string,
  teaser: PropTypes.string,
  comparisonCards: PropTypes.instanceOf(Array),
  animation: PropTypes.instanceOf(Object),
};

export default ComparisonGallerySwitcher;
